<template>
  <div id="campaign-list">
    <call />
    <pop-alert />
    <top-bar title="抽選会" backUrl="/"/>
    <!-- main -->
    <main>
      <!-- nav bot -->
      <footer-app page="campaign"></footer-app>
      <!-- search -->
      <section :class="{ 'fade-base': true, 'fade': pageFade }">
        <div class="pb-38">
          <div class="p-16" v-if="campaignList.length == 0">
            ただいま掲載中の抽選会はありません
          </div>
          <div v-else class="l-campaign--body">
            <ul class="l-campaign-list">
              <li v-for="(campaign, index) in campaignList" :key="index + campaign.id">
                <div @click="handleOpenModal(campaign.id)">
                  <viewImage
                    type="campaign"
                    :img="campaign.image"
                  />
                  <div class="c-campaign-list__info">
                    <div class="c-info--guide">
                      <div>{{ campaign.title }}</div>
                    </div>
                    <expirationDate
                      type="campaign"
                      :unlimited="false"
                      :availableFrom="campaign.lotteryStartAt"
                      :availableTo="campaign.lotteryEndAt"
                      :isEntered="campaign.isEntered"
                      :isEnded="campaign.isEnded"
                    />
                  </div>
                </div>

                <div class="c-campaign-list__close" v-if="campaign.isEnded" @click="handleOpenModal(campaign.id)">
                  <div :class="`c-campaign-list__close_message ${campaign.isEntered && islogin && 'widthMax'}`">
                   <template v-if="campaign.isEntered && islogin">
                     <div class="c-obi">済</div>
                    <h3>抽選済です</h3>
                    <template v-if="getLotteryResult(campaign.id) == 1">
                    <h4 >
                      抽選結果：
                      <b class="color-8">当たり</b>
                    </h4>
                    <p>
                      <router-link :to="`/coupons?category=LotteryCoupon`" class="color-7">
                      クーポン一覧
                      </router-link>
                      をご確認ください
                    </p>
                    </template>
                    <template v-else-if="getLotteryResult(campaign.id) == 2">
                      <h4 >
                      抽選結果：
                      <b class="color-9">はずれ</b>
                    </h4>
                    <p>また挑戦してください</p>
                    </template>
                   </template>
                    <div v-if="campaign.isEnded">
                      予定本数は終了しました
                    </div>

                    </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <modal :open="openModal" @close="() => {
        openModal = false;
        this.$router.push({ query: {} });
      }">
        <campaign-detail :campaignId="campaignId" />
      </modal>
    </main>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import Footer from "../components/Footer.vue";
import { Common } from "../common/common.js";
import { Tenant } from "../plugin/mixin.js";
import { getLocalCampaignList, getServerCampaignList, getLotteryEnteredData } from "../store/firestore.js";
import PopAlert from "../components/PopAlert.vue";
import viewImage from "../components/parts/viewImage.vue"
import expirationDate from "../components/parts/expirationDate.vue"
import TopBar from "../components/TopBar.vue";
import Modal from "../components/Modal.vue";
import CampaignDetail from "./CampaignDetail.vue";

export default Vue.extend({
  name: "CampaignList",
  components: {
    'footer-app': Footer,
    PopAlert,
    viewImage,
    expirationDate,
    TopBar,
    Modal,
    CampaignDetail
  },
  mixins: [Tenant],
  data() {
    return {
      campaignList: [],
      getLocalCampaignList: getLocalCampaignList,
      getServerCampaignList: getServerCampaignList,
      getLotteryEnteredData: getLotteryEnteredData,
      campaignResultList: {},
      openModal: false,
      campaignId: "",
    }
  },
  async created() {
    await this.getDataCampaigns()
    //this.islogin()
  },
  mounted() {
    Common.initDom();
  },
  computed: {
    islogin: function () {
      return this.isUserLoggedIn()
    }
  },
  watch: {
    islogin() {
      this.$nextTick(() => {
        console.log('変更されました')
        console.log("isUserLoggedIn 3", this.isUserLoggedIn())
        if (this.isUserLoggedIn()) {
          const { userId } = this.$store.state
          this.campaignList.map(async (campaign) => {
            const result = await this.getLotteryEnteredData(this.SHOP_ID, campaign.id, userId);
            if (result && result.length > 0) {
              this.campaignResultList[campaign.id] = result[0]
            }
          })
        }
      })
    },
    '$route.query': {
      handler: function (newVal) {
        if (!newVal.id) {
          this.openModal = false
          return;
        }
        this.campaignId = newVal.id
        this.openModal = true
      },
      immediate: true
    }
  },
  updated() {
    this.$nextTick(function () {
      Common.setKeepRatio()
    })
  },
  methods: {
    async getDataCampaigns() {
      const result = await this.getLocalCampaignList();
      if (result) {
        this.campaignList = result;
      }
      setTimeout(async () => {
        const result = await this.getServerCampaignList();
        if (result) {
          this.campaignList = result;
        }
      });
    },
    getLotteryResult(campaignId) {
      if (this.campaignResultList[campaignId]) {
        return  this.campaignResultList[campaignId].lotteryResult
      }
      return 0
    },
    handleOpenModal(campaignId) {
      this.openModal = true;
      this.campaignId = campaignId;
      this.$router.push({ query: { id: campaignId } });
    },
  }
});
</script>